/** Bound room/filial filter values for car-category and room dropdowns */
export type PassageFormRoomCategoryFilterIds = number[] | null | undefined;

/** Filter input is not bound (no client or event context) */
export const PASSAGE_FORM_ROOM_CATEGORY_FILTER_NOT_BOUND: undefined = undefined;

/** Filter is bound but there are no matching room/filial ids */
export const PASSAGE_FORM_ROOM_CATEGORY_FILTER_EMPTY: null = null;

/** Separator for stable comparison of room id sets in {@link haveRoomIdsChanged} */
export const PASSAGE_FORM_ROOM_IDS_COMPARE_SEPARATOR = ',';
